export const FETCHING_TREENODES = 'FETCHING_TREENODES'
export const FETCHED_TREENODES = 'FETCHED_TREENODES'
export const FETCHING_USER_TREENODES = 'FETCHING_USER_TREENODES'
export const FETCHED_USER_TREENODES = 'FETCHED_USER_TREENODES'


export function treeNodes(treeNodes={isFetching: false, data: []}, action) {
  switch(action.type) {
    case FETCHING_TREENODES:
      return {
        isFetching: true,
        data: [],
      }
    case FETCHED_TREENODES:
      return {
        isFetching: false,
        data: action.treeNodes,
      }
    default:
      return treeNodes
  }
}
